// Types
import type { ApplicationProps } from '@/types/config'

const Config: ApplicationProps = {
	name: process.env.APP_NAME || 'rateup',
	shortName: process.env.APP_SHORT_NAME || 'rateup-site',
	siteUrl: process.env.SITE_URL || 'https://rateup.ir',
	testSiteUrl: process.env.TEST_SITE_URL || '',
	appUrl: process.env.APP_URL || 'https://app.rateup.ir'
}

export default Config
